import * as Sentry from '@sentry/react';

export default {
  initSentry: (SENTRY_DSN: string) =>
    Sentry.init({
      dsn: SENTRY_DSN,
      integrations: [
        // Keep the Replay integration as before
        Sentry.replayIntegration(),

        // The following is all you need to enable canvas recording with Replay
        Sentry.replayCanvasIntegration(),
      ],
      ignoreErrors: [
        'ResizeObserver loop limit exceeded',
        'ResizeObserver loop completed with undelivered notifications.',
        /Non-Error promise rejection captured with keys/,
        /Non-Error promise rejection captured/,
        /Object captured as promise rejection with keys/,
        /UnhandledRejection/,
        /Request aborted/,
        /AbortError: The play() request was interrupted by a new load request/,
      ],

      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      tracesSampleRate: 1.0,

      // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
      // tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],

      // Capture Replay for 10% of all sessions,
      // plus for 100% of sessions with an error
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 0,
    }),
};
